/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BuildingJpvDto { 
    budId?: number;
    caobceKod?: number;
    caobceNazev?: string;
    cisloDomovni?: number;
    docasnaStavba?: string;
    endDate?: string;
    id?: number;
    jeSoucasti?: string;
    katuzeKod?: number;
    katuzeNazev?: string;
    lv?: number;
    psId?: number;
    startDate?: string;
    typbudKod?: number;
    typbudNazev?: string;
    zpvybuKod?: number;
    zpvybuNazev?: string;
}

